"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgRoute(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M18 0a2 2 0 11-.536 3.927l-3.532 3.554a2.003 2.003 0 01-2.446 2.452l-3.54 3.605a2 2 0 11-1.375-1.455l3.498-3.562a2.003 2.003 0 012.448-2.454L16.063 2.5A2.004 2.004 0 0118 0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Route')(SvgRoute);
//# sourceMappingURL=Route.js.map